
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"70","height":"85","viewBox":"-3 0 70 85"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"transform":"translate(2 2)","filter":"url(#oeamtc-floating__dropshadow)","fill":"var(--color-accent-primary)","d":"M29.5 68.263a3.37 3.37 0 110 6.737 3.37 3.37 0 110-6.737zM29.5 0C45.792 0 59 13.44 59 30.017c0 12.482-7.487 23.184-18.14 27.71-9.09 4.616-10.225 8.852-11.36 8.852-1.135 0-2.27-4.236-11.278-8.817C7.525 53.255 0 42.53 0 30.017 0 13.439 13.208 0 29.5 0z"}}),_c('path',{attrs:{"d":"M31.604 20.41c4.704 0 8.517 3.86 8.517 8.622 0 4.224-3.001 7.738-6.963 8.477l-.942 11.9a.608.608 0 01-1.21 0l-.92-11.893c-3.98-.724-7-4.247-7-8.484 0-4.762 3.813-8.621 8.518-8.621z"}})])
          )
        }
      }
    